import React from 'react';
import { ISubMenuItemConfig, NavigationSubMenu } from './NavigationSubMenu';
import { SectionParentNavItem } from '../main/sections/SectionParentNavItem';
import { StyledMainNavListItemWrapper } from '../main/StyledNavigationItems';

interface ISectionWithSubmenuNavItemProps {
	className?: string;
	contentWidth?: string;
	relativeSubMenu?: boolean;
	open: boolean;
	title: string;
	subMenuItems: ISubMenuItemConfig[];
	isMobileView?: boolean;
	onClick: () => void;
	onItemClick?: () => void;
}
export const SectionWithSubmenuNavItem = ({
	className,
	contentWidth = 'max-content',
	relativeSubMenu = false,
	title,
	open,
	subMenuItems,
	isMobileView,
	onClick,
	onItemClick,
}: ISectionWithSubmenuNavItemProps) => (
	<StyledMainNavListItemWrapper className={className} role="none">
		<SectionParentNavItem
			title={title}
			open={open}
			onClick={onClick}
			isMobileView={isMobileView}
		/>

		<NavigationSubMenu
			className={className}
			width={contentWidth}
			subMenuItems={subMenuItems}
			open={open}
			relativeSubMenu={relativeSubMenu}
			onItemClick={onItemClick}
		/>
	</StyledMainNavListItemWrapper>
);
